import { createCrudSlice, createCrudSelectors } from "./CrudRedux"

const alertsSlice = createCrudSlice({
  name: "alerts",
});

export const AlertsActions = alertsSlice.actions;

export const AlertsSelectors = {
  ...createCrudSelectors({ name: "alerts" }),
};

export default alertsSlice.reducer;
